<template>
  <div id="app">
    <div id="wrapper" class="wrapper box_layout">
      <!-- Header -->
      <div class="container">
        <b-navbar toggleable="lg" type="light">
          <b-navbar-brand href="#"><img src="./assets/img/logo/logo.svg" class="d-inline-block align-top" alt="logo"
              style="height: 50px;" /></b-navbar-brand>
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
          <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto"></b-navbar-nav>
            <b-nav align="center">
              <b-nav-item to="/home">主页 Home</b-nav-item>
              <b-nav-item to="/prod">产品 Products</b-nav-item>
              <b-nav-item to="/about">关于我们 About</b-nav-item>
              <b-nav-item to="/contact">联系我们 Contact</b-nav-item>
            </b-nav>
          </b-collapse>
        </b-navbar>
      </div>

      <!-- Header-end -->

      <!-- router-view -->
      <div>
        <transition name="el-zoom-in-top" mode="out-in" :key="$route.fullPath"><router-view></router-view></transition>
        <transition name="el-zoom-in-center" mode="out-in"><router-view name="a" :key="$route.fullPath"></router-view>
        </transition>
      </div>
      <!-- router-view -->

      <!-- Start Footer Area -->
      <footer class="footer_area">
        <div class="footer_top bg-cat--1">
          <div class="container">
            <div class="row">
              <!-- Start Single Footer -->
              <div class="col-lg-4 col-sm-6 col-12 hidden-sm-and-down">
                <div class="footer_widget">
                  <h2 class="ft_widget_title">CleanNova (Beijing) BioTech Co., Ltd.</h2>
                  <div class="textwidget">
                    <p>
                      Suite 1507,15th Floor, Building 6, No.6,8,10,12,16,18 Xuanwumenwai Avenue, Xicheng District,
                      Beijing, PRC
                    </p>
                    <p>
                      Tel: 0086-0572-5817231
                    </p>
                    <p>
                      sales@chemcleanchina.com <br>
                      sales1@chemcleanchina.com
                    </p>
                  </div>
                </div>
              </div>
              <!-- End Single Footer -->
              <!-- Start Single Footer -->
              <div class="col-lg-4 col-sm-6 col-12">
                <div class="footer_widget">
                  <h2 class="ft_widget_title">中国总部</h2>
                  <div class="textwidget">
                    <p>康洁来（北京）生物科技有限公司</p>
                  </div>
                </div>
              </div>
              <!-- End Single Footer -->
              <!-- Start Single Footer -->
              <div class="col-lg-4 col-sm-6 col-12">
                <div class="footer_widget">
                  <h2 class="ft_widget_title">联系我们</h2>
                  <div class="textwidget">
                    <p>地址：北京市西城区宣武门外大街6、8、10、12、16、18号6号楼15层1507</p>
                    <p>电话：+86-0572-5817231</p>
                    <p>邮箱：sales@chemcleanchina.com <br>
                      sales1@chemcleanchina.com</p>
                  </div>
                </div>
              </div>
              <!-- End Single Footer -->
            </div>
          </div>
        </div>
        <div class="copyright bg-cat--2">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-lg-12">
                <div class="copy_text">
                  <p>
                    Copyright &copy; 2016-{{new Date().getFullYear()}} 康洁来（北京）生物科技有限公司 All rights reserved.
                    <a target="_blank" href="http://beian.miit.gov.cn/">备案号：京ICP备2025147794号</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <!-- End Footer Area -->
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    methods: {},
    mounted() {}
  }
</script>

<style>
  @import './assets/css/plugins.css';
  @import './assets/style.css';
</style>
